import { signOut } from "firebase/auth";
import TicketsbyDingPayWhiteLogo from "../assets/imgs/tbdingpay-white-logo.svg";
import TicketsbyDingPayLogo from "../assets/imgs/tbdingpay-logo.svg";
import { firebaseAuth } from "../utils/firebase";
import { toast } from "react-toastify";
import {
  createGradient,
  INTERNAL_ADMIN_IS_LOGGEDIN,
  LOGGED_IN_ADMIN_EVENTS,
} from "../utils";
import { useParams } from "react-router-dom";
import { PAGE_STEPS } from "../pages/customer/event";

export function CustomerHeader({
  themeStyle,
  pageStep,
  children,
}: {
  themeStyle?: { backgroundColours: string[] };
  pageStep?: string;
  children?: React.ReactNode;
}) {
  return (
    <div
      className='header'
      style={{
        background: themeStyle?.backgroundColours
          ? createGradient(themeStyle.backgroundColours)
          : "#fff",
      }}
    >
      <div
        onClick={() => {
          if (pageStep && pageStep === PAGE_STEPS.PAYMENT_SUCCESS)
            return window.location.reload();
        }}
        style={{ cursor: "pointer" }}
      >
        <img
          src={
            (themeStyle?.backgroundColours ?? [])?.length
              ? TicketsbyDingPayWhiteLogo
              : TicketsbyDingPayLogo
          }
          alt='logo'
          className='img-fluid logo-img'
        />
      </div>
      {children}
    </div>
  );
}

export function AdminHeader({ type = "admin" }) {
  const { eventId } = useParams();

  const handleLogout = async () => {
    try {
      const storedAdminEvents = localStorage.getItem(LOGGED_IN_ADMIN_EVENTS);
      const storedAdminEventsData = storedAdminEvents
        ? JSON.parse(storedAdminEvents)
        : [];
      const filteredAdminEventsData = storedAdminEventsData.filter(
        (lsEvent: { data: string }) => lsEvent.data !== eventId
      );
      // checks if after removing the eventId to logout from, there are no events left
      if (!filteredAdminEventsData.length) {
        await signOut(firebaseAuth);
        localStorage.clear();
      } else {
        localStorage.setItem(
          LOGGED_IN_ADMIN_EVENTS,
          JSON.stringify(filteredAdminEventsData)
        );
      }
      window.location.href = "/admin/login";
      return toast.success("Logged out successfully");
    } catch (error) {
      console.log(error);
      return toast.error("Error logging out");
    }
  };

  return (
    <div className='header'>
      <div className='header__logo'>
        <img src={TicketsbyDingPayLogo} alt='logo' className='img-fluid logo' />
      </div>
      {type === "internal-admin" ? (
        <button
          className='internal-admin-logout-btn'
          onClick={async () => {
            await signOut(firebaseAuth);
            localStorage.removeItem(INTERNAL_ADMIN_IS_LOGGEDIN);
            window.location.href = "/internal/login";
          }}
        >
          <i className='bi bi-arrow-bar-right'></i>
        </button>
      ) : (
        <div className='dropdown'>
          <a
            className='btn dropdown-toggle'
            role='button'
            data-bs-toggle='dropdown'
            aria-expanded='false'
            aria-label='User menu'
            href='##'
          />
          <ul className='dropdown-menu'>
            <li>
              <a
                className='dropdown-item'
                href='mailto:main@usedingpay.com?cc=support@usedingpay.com'
                target='_blank'
                rel='noopener noreferrer'
              >
                Contact Support
              </a>
            </li>
            <li onClick={handleLogout}>
              <a className='dropdown-item' href='##'>
                Log out
              </a>
            </li>
          </ul>
        </div>
      )}
    </div>
  );
}
